// Novel Embed Script
(async()=>{
  const e="681d41f2cc07030008157dde",
        t="novel-embed-script-681d41f2cc07030008157dde",
        s=document.getElementById(t)
  if(!s) return;
  const n=t=>{
          window[`prefetchedJourneyRelease_${e}`]=t;
          const n=document.createElement("script");
          n.setAttribute("src","https://embed-js.benovel.com/embed/index.js");
          n.setAttribute("journey-id",e);
          n.setAttribute("async","");
          s.appendChild(n)
        },
        o=await fetch(`https://eg2o7r7cs9.execute-api.us-west-2.amazonaws.com/prod/api/v2/journeys/${e}/releases?type=PUBLISH&sort=createdAt&order=DESC&size=1`),
        r=await(o?.json());
  
  if(r?.length&&r[0].isPublished&&"overlay"===r[0].embedConfigs[0]?.embedType?.uniqueName?.toLowerCase()){
    const e=()=>{
      document.documentElement.scrollTop>=25&&(n(r[0]),window.removeEventListener("scroll",e))
    };
    window.addEventListener("scroll",e)
  }else{
    new IntersectionObserver(((e,s)=>{
      if(e)for(const o of e)if(o.target.id===t&&o.isIntersecting){
        s.unobserve(o.target);
        n(r[0]);
        break
      }
    }),{root:null,rootMargin:"0px",threshold:0}).observe(s)
  }
})()
